import { useState } from "react";
import type { ActorAccess } from "src/contexts/documentationArea/domain/ActorAccess";
import { NotificationStyles } from "src/contexts/_shared/domain/NotificationStyles";
import { useDeleteDocumentationAreaActorUser } from "src/apps/hooks/useDeleteDocumentationAreaActorUser";
import { useNotifications } from "src/apps/hooks/useNotifications";
import { createActorAccessNotification } from "src/apps/hooks/createActorAccessNotification";

const SUCCESS_TITLE = "documentation_area.access_actions.revoke_access.success.title";
const SUCCESS_MESSAGE = "documentation_area.access_actions.revoke_access.success.message";
const ERROR_TITLE = "documentation_area.access_actions.revoke_access.modal.title";
const GENERIC_ERROR = "common.error.generic";

export const useActorUserRevokeAccess = (accesses: ActorAccess[], onClose: () => void) => {
  const { deleteActorUser, isPending } = useDeleteDocumentationAreaActorUser();
  const { addNotifications } = useNotifications();
  const [userLinkId, setUserLinkId] = useState("");
  const selectedAccess = accesses.find((access) => access.userLinkId === userLinkId);

  const resetAndClose = () => {
    setUserLinkId("");
    onClose();
  };

  const revokeAccess = () => {
    if (!selectedAccess) return;
    deleteActorUser(selectedAccess.userLinkId, {
      onSuccess: () => {
        addNotifications([
          createActorAccessNotification(SUCCESS_TITLE, SUCCESS_MESSAGE, NotificationStyles.SUCCESS),
        ]);
        resetAndClose();
      },
      onError: () => {
        addNotifications([
          createActorAccessNotification(ERROR_TITLE, GENERIC_ERROR, NotificationStyles.ALERT),
        ]);
        resetAndClose();
      },
    });
  };

  return {
    userLinkId,
    setUserLinkId,
    selectedAccess,
    isPending,
    resetAndClose,
    revokeAccess,
  };
};
